import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
    private http: HttpClient
  ) { }
  logoutSvc(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        refreshToken: localStorage.getItem('refreshToken')
      })
    };

    const url = environment.apiUrl + environment.activationPortal.logout;
    const data = {
      deliteId: localStorage.getItem('userId')
    };
    return this.http.post(url, data, httpOptions).pipe(
      map((returndata: any) => {
        console.log('user logged out');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('loggedInUserData');
        localStorage.removeItem('mobileNo');
        return returndata;
      }),
      catchError(this.errorMgmt)
    );
  }

  // Error handling
  errorMgmt(error: HttpErrorResponse) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = error;
    }
    return throwError(errorMessage);
  }
}
